import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Autocomplete, Backdrop, Button, CircularProgress, Snackbar, TextField } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { getFiltrarLocales, postAddLocalBeneficio, postUpdateLocalBeneficio } from "../../../api/ApiService";
import { useSelector } from "react-redux";
import { CssTextField } from "../../../styles/styles";



function AdherirLocalPage() {
    const [cargando, setCargando] = useState(false);
    const [observacion, setObservacion] = useState('');

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [locales, setLocales] = useState([]);
    const [LocalesSearch, setLocalesSearch] = useState('');
    const [localesSelected, setLocalesSelected] = useState(null);
    const [loadingCargarLocales, setLoadingCargarLocales] = useState(false);

    const stateToken = useSelector(state => state.reducerGlobal.token);


    const location = useLocation();
    const { state } = location;
    // console.log("state-AdherirLocalPage", state);

    let { id } = useParams();

    const navigate = useNavigate();

    const rutaListadoBeneficiosLocales = `/app/admin/beneficios-locales/${id}`;


    useEffect(() => {
        if (id) {
            setCargando(true);

            if (state?.status === "editar") {
                setObservacion(state?.data?.observacion);
            }


        } else {
            setCargando(true);
            setObservacion('');
        }
    }, [id, state]);


    //=================================================================================================funcion para listar las categorias
    const handleListarLocales = (busqueda) => {
        const body = {
            page: 1,
            per_page: 50,
            estado: "activo",
            nombre: busqueda,
            categoriaId: ""
        };

        getFiltrarLocales(stateToken?.access_token, body)
            .then((response) => {
                console.log("response-getFiltrarLocales", response?.data);
                setLoadingCargarLocales(false);
                if (response?.data && response.data.length > 0) {
                    setLocales(response.data);
                } else {
                    setLocales([]);
                }
            })
            .catch((error) => {
                console.log("error-getFiltrarLocales", error);
                setLoadingCargarLocales(false);
                setLocales([]);
            });
    };




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };








    //=========================================================funcion para guardar
    const handleGuardar = () => {

        let body = {
            observacion: observacion,
            local_id: localesSelected?.id,
            beneficio_id: id,
        }

        //validar campos que no esten vacios
        if (localesSelected === null) {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Seleccione un local');

        } else if (observacion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo observación es obligatorio');

        } else {

            setLoadingGuardar(true);

            handleAddLocalBeneficioApi(body);
        }
    };

    //=========================================================api de adherir local a beneficio
    const handleAddLocalBeneficioApi = (body) => {

        postAddLocalBeneficio(body, stateToken?.access_token)
            .then((response) => {
                console.log("response-postAddLocalBeneficio", response);
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');
                    // window.history.back();

                    setTimeout(() => {
                        navigate(rutaListadoBeneficiosLocales);
                    }, 1500);

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postAddLocalBeneficio", error);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar el beneficio');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };









    //=========================================================funcion para actualizar
    const handleActualizar = () => {

        let body = {
            observacion: observacion,
            local_id: state?.data?.local_id,
            beneficio_id: state?.data?.beneficio_id,
        }

        //validar campos que no esten vacios
        if (observacion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo observación es obligatorio');

        } else {

            setLoadingGuardar(true);

            handleUpdateBeneficioApi(body);
        }
    };


    //=========================================================api de actualizar beneficio
    const handleUpdateBeneficioApi = (body) => {

        postUpdateLocalBeneficio(body, stateToken?.access_token)
            .then((response) => {
                console.log("response-postUpdateLocalBeneficio", response);
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');
                    // window.history.back();

                    setTimeout(() => {
                        navigate(rutaListadoBeneficiosLocales);
                    }, 1500);

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postUpdateLocalBeneficio", error);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };



















    //=========================================================funcion para seleccionar local
    const handleLocalSelected = (value) => {
        console.log("value-handleCategoriaSelected: ", value);
        setLocalesSelected(value);
    };

    //=========================================================funcion para buscar local
    const handleSearchLocal = (value) => {
        console.log("value-handleSearchCategoria: ", value);
        setLocalesSearch(value);

        if (value.length > 0) {
            setLoadingCargarLocales(true);
            handleListarLocales(value);
        }
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">
                            {state?.status !== "agregar" ? 'Editar Beneficio' : `Agregar Locales a Beneficio ${state?.beneficio}`}
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
                            <div className="p-6 grid grid-cols-1 gap-6">
                                {state?.status !== "editar" && (
                                    <div className="max-w-2xl">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Locales (Buscar por nombre de fantasía)
                                        </label>

                                        <Autocomplete
                                            disablePortal
                                            options={locales}
                                            loading={loadingCargarLocales}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Seleccione"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {loadingCargarLocales ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            onChange={(a, b) => {
                                                handleLocalSelected(b);
                                            }}
                                            onInputChange={(event, newInputValue, reason) => {
                                                if (reason === 'input') {
                                                    console.log("reason.........>>", reason);
                                                    handleSearchLocal(newInputValue);
                                                }
                                            }}
                                            value={localesSelected || null}
                                            getOptionLabel={(option) => option?.nombre_fantasia || ''}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            getOptionKey={(option) => option.id}
                                            loadingText={'Cargando...'}
                                            noOptionsText={'No hay opciones'}
                                        />
                                    </div>
                                )}

                                <div className="max-w-2xl">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Descripción del beneficio
                                    </label>

                                    <CssTextField
                                        value={observacion}
                                        onChange={(e) => setObservacion(e.target.value)}
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        label="Descripción del beneficio"
                                        autoCapitalize='none'
                                        autoCorrect={"false"}
                                    />
                                </div>

                                <div className="flex flex-wrap items-center gap-4 pt-2">
                                    <Button variant="contained" onClick={state?.status !== "agregar" ? handleActualizar : handleGuardar}>
                                        {state?.status !== "agregar" ? 'Actualizar' : 'Guardar'}
                                    </Button>

                                    <Button variant="outlined" onClick={handleCancelar}>
                                        Cancelar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ) : <SkeletonLoading />
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AdherirLocalPage;